module.exports = __webpack_public_path__ + "img/iconePortable.49247abe.svg";